export default "__VITE_ASSET__fad24511__"